import React from 'react'
import TopBar from './TopBar'
import MenuBar from './MenuBar'

const Header = () => {

    return (
      <>
        <TopBar />
        <MenuBar />
       </>
    )
}

export default Header